import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const PUT_BILLING_CODE_RESET = 'PUT_BILLING_CODE_RESET';
export const PUT_BILLING_CODE_LOADING = 'PUT_BILLING_CODE_LOADING';
export const PUT_BILLING_CODE_SUCCESS = 'PUT_BILLING_CODE_SUCCESS';
export const PUT_BILLING_CODE_REJECT = 'PUT_BILLING_CODE_REJECT';

//* ACTIONS ------------------------------------------------
export const putBillingCodeReset = () => ({ type: PUT_BILLING_CODE_RESET });
export const putBillingCodeLoading = () => ({ type: PUT_BILLING_CODE_LOADING });
export const putBillingCodeSuccess = (payload) => ({ type: PUT_BILLING_CODE_SUCCESS, payload });
export const putBillingCodeReject = (payload) => ({ type: PUT_BILLING_CODE_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const putBillingCodeRequest = async (data = {}, getState) => {
    const options = await withToken({
        method: Methods.PUT,
        data,
    }, getState);
    return request(`/BillingCode/web/UpdateBillingCode`, options);
};
